import { useCallback, useRef } from 'react';

import { vrsConferenceTerminationDecider } from 'features/call/vrs-conference-call/helpers';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { closeCall, handleResetCall } from 'features/call/call-base/store';
import { resetCallWasPlaced } from 'features/call/vrs-call/store';
import { resetReportingState } from 'features/reporting/store';
import { callIdSelector } from 'features/call/call-base/store/selectors';
import { CallTimerDaoService } from 'features/call/call-timer/services';
import { sendZoomMeetingEnded } from 'features/call/call-conference/helpers';
import {
  setIsReportNeeded,
  resetCallComments,
} from 'features/call/vrs-call-comments/store';
import { getDetailsForConferenceClose } from 'features/call/call-conference/store';

export const useVrsCallFinishConference = () => {
  const dispatch = useAppDispatch();
  const isCloseCallMade = useRef(false);
  const callId = useAppSelector(callIdSelector);

  const handleCloseCallVrsConference = useCallback(
    async (wasPrimaryVco: boolean) => {
      if (isCloseCallMade.current) {
        return;
      }

      const { currentTerminationType, didAgentGetConnectedToConferenceRoom } =
        await dispatch(getDetailsForConferenceClose()).unwrap();

      try {
        if (wasPrimaryVco) {
          const interpretTime =
            await CallTimerDaoService.getTotalInterpretTime(callId);

          const terminationType = vrsConferenceTerminationDecider({
            currentTerminationType,
            interpretTime,
            didAgentGetConnectedToConferenceRoom,
          });

          dispatch(sendZoomMeetingEnded(terminationType, interpretTime));
          await dispatch(
            closeCall({
              terminationType,
            })
          ).unwrap();
        }

        isCloseCallMade.current = true;
      } catch (error) {
        console.error('DEBUG: Error in handleCloseCallVrsConference:', error);
      } finally {
        dispatch(resetCallWasPlaced());
        dispatch(resetReportingState());
        dispatch(setIsReportNeeded(false));
        dispatch(resetCallComments());
        dispatch(handleResetCall());
      }
    },
    [callId, dispatch]
  );

  return { handleCloseCallVrsConference };
};
